<template>
  <div class="blog-page">
    <div class="blog-page__content container">
      <!--            <ScreenHeader class="blog-page__header" data-aos="fade-down">-->
      <!--              <template #subtitle>-->
      <!--                Stay in touch-->
      <!--              </template>-->
      <!--              <template #title>-->
      <!--                Blog-->
      <!--              </template>-->
      <!--              <template #text>-->
      <!--                Explore the heart and soul of Speedway Games through our blog. Gain insights into our company culture and stay-->
      <!--                updated on the latest developments in our journey!-->
      <!--              </template>-->
      <!--            </ScreenHeader>-->
      <div class="blog-page__filter">
        <ButtonSelect
          class="blog-page__type-select"
          :options="articleTypeOptions"
          v-model="selectedArticleType"
          v-if="articleTypeOptions.length > 2"
          data-aos="fade"
        />
      </div>
      <div
        class="blog-page__highlighted-articles"
        v-if="highlightedArticles"
        data-aos="fade"
        data-aos-delay="100"
      >
        <BlogArticleCard
          class="blog-page__article-card"
          v-for="(article, i) in highlightedArticles"
          :key="article.id"
          :background-image="article.previewImageUri"
          :published-at="article.publishedAt"
          :title="article.title"
          :views="article.views"
          :url="article.url"
          :extended="true"
          :short-description="article.shortDescription"
          :type="article.type"
        />
      </div>
      <div
        class="blog-page__other-articles"
        v-if="otherArticles"
        data-aos="fade"
        data-aos-delay="100"
      >
        <BlogArticleCard
          class="blog-page__article-card"
          v-for="article in otherArticles"
          :key="article.id"
          :background-image="article.previewImageUri"
          :published-at="article.publishedAt"
          :title="article.title"
          :views="article.views"
          :url="article.url"
          :short-description="article.shortDescription"
          :type="article.type"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ButtonSelectOption } from "@website/components/selects/ButtonSelect.vue";

  definePageMeta({
    settings: {
      cover: {
        title: "News",
      },
    },
  });

  const { getAllNews } = useWebsiteContent();
  const { data: articles, suspense: articlesSuspense } = getAllNews();
  await articlesSuspense();

  const articleTypes = computed(() =>
    articles.value?.data.reduce<string[]>((types, article) => {
      const normalizedType = article.type.trim().toLowerCase();
      if (!types.includes(normalizedType)) types.push(normalizedType);

      return types;
    }, []) ?? []
  );
  const articleTypeOptions = computed<ButtonSelectOption[]>(() => [
    {
      label: "All",
      value: "all",
    },
    ...articleTypes.value.map((type) => ({
      label: type,
      value: type,
    })),
  ]);
  const selectedArticleType = ref<string>("all");

  function isArticleMatchFilter(article: any) {
    return (
      selectedArticleType.value === "all" ||
      selectedArticleType.value.trim().toLowerCase() ===
        article.type.trim().toLowerCase()
    );
  }

  const highlightedArticles = computed(() =>
    articles.value?.data.filter(
      (article) => article.highlighted && isArticleMatchFilter(article)
    )
  );
  const otherArticles = computed(() =>
    articles.value?.data.filter(
      (article) => !article.highlighted && isArticleMatchFilter(article)
    )
  );
</script>

<style lang="scss">
  .blog-page {
    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;

      padding-top: 64px;
      padding-bottom: 64px;
    }

    &__header {
      max-width: 512px;
    }

    &__grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      //justify-content: center;
      align-items: flex-start;
      gap: 32px;

      @media (max-width: $xl) {
        display: flex;
        flex-direction: column;
      }
    }

    &__card {
      &_highlighted {
        width: 100%;
      }
    }

    &__highlighted-articles {
      display: flex;
      align-items: flex-start;
      gap: 32px;

      @media (max-width: $lg) {
        flex-direction: column;
      }

      .blog-page__article-card {
        flex: 1 0 0;
      }
    }

    &__other-articles {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: flex-start;
      gap: 32px;

      @media (max-width: $xl) {
        display: flex;
        flex-direction: column;
      }
    }

    &__type-select {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
</style>
